import React, { createContext, useContext, useEffect, useState } from 'react';
import { smarttix } from '../services/api';
import { HEALTH_POLL_MS } from '../constants';

// <purpose>App-level maintenance flag, sourced from the /tickets/health poll
// (maintenanceMode field). Drives the banner + write-disable. A network error
// is NOT maintenance — leave the last known value rather than flapping.</purpose>
const MaintenanceContext = createContext<boolean>(false);

export const useMaintenanceMode = (): boolean => useContext(MaintenanceContext);

export const MaintenanceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const h = await smarttix.checkHealth();
        if (alive) setActive(!!h.maintenanceMode);
      } catch {
        /* network error ≠ maintenance — keep last known value */
      }
    };
    poll();
    const id = setInterval(poll, HEALTH_POLL_MS);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return <MaintenanceContext.Provider value={active}>{children}</MaintenanceContext.Provider>;
};
